import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面不存在 - 91大神影视平台',
    description: '你访问的页面不存在，返回 91大神影视平台首页浏览最新电影、剧集与综艺推荐。',
    keywords: '91大神, 404, 影视平台',
    canonicalPath: '/',
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center justify-center px-4 py-24 text-center">
        <p className="font-display text-5xl font-extrabold text-accent-500">404</p>
        <h1 className="mt-3 font-display text-xl font-bold text-foreground-950">找不到这个页面</h1>
        <p className="mt-2 max-w-md text-sm text-foreground-500">
          链接可能已经失效。你可以回到首页，或者直接进入想看的频道。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
          >
            电影频道
          </Link>
          <Link
            to="/news"
            className="whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
          >
            影视资讯
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}